import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = (props: SvgProps) => (
    <Svg width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
        <Path
            d="M6 2.25C3.5 2.25 2.5 4.25 2.5 6.75V9.25L4.5 8.25L6 9.25L7.5 8.25L9.5 9.25V6.75C9.5 4.25 8.5 2.25 6 2.25Z"
            stroke={props.color || ds.colorValue.icon.primary}
            strokeWidth={1.5}
            strokeLinejoin="round"
        />
    </Svg>
);
export { SvgComponent as GhostIcon };
